export namespace StockLocationTranslations {
  export const common = {
    stockLocation: 'stockLocation',
    destinationStockLocationName: 'destinationStockLocationName',
    destinationStockLocationIdentifier: 'destinationStockLocationIdentifier',
    sourceStockLocationName: 'sourceStockLocationName',
    sourceStockLocationIdentifier: 'sourceStockLocationIdentifier',
  } as const;

  export const mobileLocations = {
    mobileStockLocationSessionLocationPermissionToBeGrantedDescription:
      'mobileStockLocationSessionLocationPermissionToBeGrantedDescription',
    mobileStockLocationSessionLocationPermissionDeniedDescription:
      'mobileStockLocationSessionLocationPermissionDeniedDescription',
    mobileStockLocationSessionLocationEndSession: 'mobileStockLocationSessionLocationEndSession',
    mobileStockLocationSessionLocationSetupPermissions: 'mobileStockLocationSessionLocationSetupPermissions',
    mobileStockLocationSessionLocationStartSession: 'mobileStockLocationSessionLocationStartSession',
  } as const;

  export const error = {
    stockLocationsUnableToLoadError: 'stockLocationsUnableToLoadError',
  } as const;
}
